/**
 * For "public" methods we are using relative imports, to not throw errors of trying to import frontend modules inside backend env
 * and pkg consumer needs to import these in backend env as follows:
 * import { methodName } from "@hisense-staging/velo-npm/backend";
 *
 */
module.exports = {
  ...require('../public/data'),
  ...require('../public/product/data'),
  ...require('./tasks'),
  ...require('./productTasks'),
  ...require('./tasksCollections'),
  ...require('./productsDataMethod'),
  ...require('./updateExistingProducts'),
};
